import * as React from "react";
import { render } from "react-dom";
import { SequencerApp } from "./View/ReactUI/SequencerApp";
let loaderDiv = document.getElementById("loader");
let hideLoader = () => {
    loaderDiv.className += " hide";
    setTimeout(() => { loaderDiv.parentElement.removeChild(loaderDiv); }, 500);
};
document.title = "WebSequencer";
render(React.createElement(SequencerApp, { hideLoader: hideLoader }), document.getElementById('root'));
//# sourceMappingURL=app.js.map